import { render, staticRenderFns } from "./MyPosts.vue?vue&type=template&id=0a2dc8fa"
import script from "./MyPosts.vue?vue&type=script&lang=ts"
export * from "./MyPosts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports